module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("To Timothy and Georgia ,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("With love bigger than the Universe and with apologies for the times I get things wrong. I can’t apologise for the question mark tank top though; you are both just going to have to come to terms with seeing me wear that in public.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("God bless xx")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb4c34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 75
// module chunks = 0